/**
 * Standard FA Solution transaction type codes.
 */
export enum TransactionType {
  DEPOSIT = "DEP",
  WITHDRAWAL = "WD",
  BUY = "B",
  SELL = "S",
  SUBSCRIPTION = "FUS", // FA Standard is "SUB"
  REDEMPTION = "RED", // FA Standard, but presumably not in use
  REDEMPTION_UNITS = "FUDU", // Alfred Berg Fund redemption units
  REDEMPTION_CASH = "FUD", // Alfred Berg Fund redemption cash
  UNDEFINED = "",
}
